import { httpPost } from '../../../modules/api/axios_api';
import Constants from '../../../constants/constants';
import { KeepAliveResponse } from './types';

export const keepAlive = async (): Promise<KeepAliveResponse> => {
  const url = `${Constants.BACKEND_URL}/keep-alive`;

  return httpPost(url, {})
    .then((response) => {
      if (response?.status === 200 && response?.data.success) {
        return {
          new_auth: response.data.new_auth,
          offline_auth: response.data.offline_auth,
        };
      }

      return false;
    })
    .catch((error) => {
      throw Error(error);
    });
};
